App.controller('ZochReportListCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'zochaReportService', '$timeout', '$stateParams', 'Blob', 'FileSaver', 'profileService', function ($scope, $sce, $state, $http, Config, $mdDialog, zochaReportService, $timeout, $stateParams, Blob, FileSaver, profileService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_report';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Lista raportów';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.dashboard';
    $scope.$emit('link', $scope.link);

    var page = 0;
    $scope.current = page;
    $scope.pageSize = 10;

    loadReports(page);

    function loadReports(page) {
        var criteria = {
            pageNumber: page,
            pageSize: $scope.pageSize
        }

        zochaReportService.dataList(criteria).then(function (data) {
            if (data.status === 200) {
                $scope.reports = data.data.data;
                // for (var a = 0; a < $scope.activities.length; a++) {
                //     $scope.activities[a].activeStatus = ($scope.activities[a].status === 'ACTIVE') ? true : false;
                // }
                $scope.numberOfPages = data.data.pages;
                // $scope.buildScroll();
            }
        });
    }

    $scope.pageChanged = function (page) {
        loadReports(page);
        $scope.current = page;
    };

    $scope.getReport = function(ev, id) {
        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }

        zochaReportService.getReport(id).then(function (data) {
            if (data.status === 200) {
                var data = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                FileSaver.saveAs(data, 'raport.xlsx');
            }

            $timeout(function() {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });
    }

    $scope.generate = function(ev) {
        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }

        var type = 'FINAL';
        zochaReportService.generate(type).then(function (data) {
            $timeout(function() {
                $(ev.currentTarget).removeClass('disabled');

                if (data.status === 200) {
                    $state.reload();
                }
            }, 1500);
        });
    }

    profileService.dataUser().then(function (data) {
        if (data.status === 200) {
            $scope.userData = data.data;

            var arrayRights = ['ADMIN'];
            for (var a = 0; a < arrayRights.length; a++) {
                if ($scope.userData.rights.indexOf(arrayRights[a]) > -1) {
                    $scope.isAccess = true;
                }
            }
        }
    });

    $scope.buildScroll = function() {
        $timeout(function() {
            scrollbarHorizontalMenu('.activitylist .scroll');
        }, 1);
    }

    function scrollbarHorizontalMenu(el) {
        $(el).mCustomScrollbar({
            axis:"x",
            theme:"dark-thin",
            autoHideScrollbar: true,
            scrollbarPosition: "outside",
            advanced:{autoExpandHorizontalScroll:true},
            callbacks:{
                onInit: function(){

                },
                onScroll: function(){

                }
            }
        });
    }
}]);
